import { render, staticRenderFns } from "./WebScreen.vue?vue&type=template&id=144072b4"
import script from "./WebScreen.vue?vue&type=script&lang=js"
export * from "./WebScreen.vue?vue&type=script&lang=js"
import style0 from "./WebScreen.vue?vue&type=style&index=0&id=144072b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports